export const ResignEN = {
  "reasonResign": {
    "column": {
      "name": "Phương tiện"
    },
    "title": "Manager resign reason",
    "breadCrumb": "Manager resign reason",
    "pageHeader": {
      "reasonResign": "Manager resign reason"
    }
  }
}
